<template>
  <div v-show="loaded">
    <label class="col-form-label">GAP Frage Aussuchen<span class="text-danger" v-show="required">*</span></label>
    <div v-show="loaded">
      <select class="form-control" :id="componentName" v-model="newQuestionID" v-select2>
      </select>
    </div>
    <div v-show="!loaded">
      <Loader></Loader>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {baseURL, service} from '@/utils/request.js';
import Loader from '@/components/component/FingerPrintSpinner'

export default {
  name: "SelectGapQuestion",
  components: {Loader},
  props: {
    componentName: {
      type: String,
      required: true
    },
    irrelevant: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'DS'
    },
    objectID: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newQuestionID: null,
      irrelevantQuestions: [],
      questionOptions: [],
      loaded: false,
      relevantLinks: {
        DS: 'todos/v1/questions/',
        AI: 'todos/v1/ai_questions/',
      },
      irrelevantLinks: {
        DS: 'todos/v1/irrelevant_questions/',
        AI: 'todos/v1/irrelevant_ai_questions/',
      }
    }
  },
  watch: {
    objectID: function(newValue) {
      if (this.loaded) $(`#${this.componentName}`).val(newValue).trigger('change')
    }
  },
  async mounted() {
    await this.selectIrrelevantQuestions()
  },
  computed: {
    ...mapState({accountid: state => state.account.accountid}),
  },
  methods: {
    async selectIrrelevantQuestions() {
      let dropdownParent = $(document.body)
      if ($(`#${this.componentName}`).parents('.modal').length != 0) {
        dropdownParent = $(`#${this.componentName}`).parents('.modal')
      }
      const url = this.irrelevant ? `${this.irrelevantLinks[this.type]}${this.accountid}/` : `${this.relevantLinks[this.type]}${this.accountid}/`
      service.request({
        url: url,
        method: 'GET',
        responseType: 'json',
      }).then((response) => {
        const groupedOptions = []
        let groupIndex = -1
        response.data.forEach((question) => {
          if (question.description) {
            groupIndex = groupedOptions.findIndex(group => group.text === question.category)
            if (groupIndex === -1) {
              groupedOptions.push({
                text: question.category,
                children: [{
                  id: question.id,
                  text: question.description,
                  last_answer: question.last_answer
                }]
              })
            } else {
              groupedOptions[groupIndex].children.push({
                id: question.id,
                text: question.description,
                last_answer: question.last_answer
              })
            }
            this.irrelevantQuestions.push(question)
          }
        })
        $(`#${this.componentName}`).select2({
          minimumResultsForSearch: 2,
          width: '100%',
          dropdownParent: dropdownParent,
          placeholder: '---',
          data: groupedOptions,
          templateResult: (state) => {
            if (!state.id || this.irrelevant || !('last_answer'in state) || ('last_answer' in state && Object.keys(state.last_answer).length === 0)) {
              return state.text;
            }
            return $(`<div class="card flex-fill" style="margin-bottom: 1.25rem!important;"><div class="card-header"><p class="card-title mb-0" style="font-size: 14px!important">${state.text}</p>
									</div>
									<div class="card-body" style="padding: 0.25rem 1.25rem!important;color: #1f1f1f!important;">
										<p class="card-text">${state.last_answer.question_answer}</p>
										<div class="d-flex"><p class="card-text mr-2">eingetragen von: ${state.last_answer.modified_by}</p><p class="card-text">am ${state.last_answer.modified_on}</p></div>
									</div>
								</div>`)
          },
          matcher: (params, data) => {
            const original_matcher = $.fn.select2.defaults.defaults.matcher;
            const result = original_matcher(params, data);
            if (params.term && params.term.length > 2) {
              if (data.children && data.children.length > 0 && data.text.toUpperCase().indexOf(params.term.toUpperCase()) >= 0) {
                result.children = data.children;
                return result
              }
            }
            return result;
          }
        }).on('change', () => {
          if (this.newQuestionID) {
            const selectedQuestion = this.irrelevantQuestions.filter(question => question.id === parseInt(this.newQuestionID))[0]
            if (selectedQuestion && selectedQuestion.id) this.$emit('questionChanged', selectedQuestion)
          }
        })
        $(`#${this.componentName}`).val(this.objectID).trigger('change')
        this.loaded = true
      })
    },
  }
}
</script>

<style scoped>

</style>
